import Fade from '@mui/material/Fade';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { viewProductBreads } from '../atoms/Header-Atoms'
import { useRecoilValue } from 'recoil';
import OliveRosemaryBread from '../images/olive-rosemary-bread.png';
import CranberryWalnutBread from '../images/cranberry-walnut-bread.png';
import Miche from '../images/miche.png';
import Sourdough from '../images/sourdough.png';
import FrenchBread from '../images/french-bread.png';
import MarbleRyeBread from '../images/marble-rye.png';
import BraidedChallahBread from '../images/braided-challa-loaf.png';
import MilkBread from '../images/milk-bread.png';
import PainDeCampagne from '../images/pain-de-campagne.png';
import LemonHerbBread from '../images/lemon-herb-bread.png';
import HoneyWheatBread from '../images/honey-wheat-bread.png';
import Foccacia from '../images/foccacia.png';
import FoccaciaSundried from '../images/focaccia-sundried.png';
import MilkBreadRolls from '../images/japanese-milk-bread-rolls.png';
import AleRolls from '../images/ale-roll.png';
import RyeSourdough from '../images/rye-sourdough.png';
import RaspberryBread from '../images/raspberry-white-chocolate.png';
import Boule from '../images/boule.png';
import PolentaBread from '../images/polenta-bread.png';

function ProductBreads() {
    const enabled = useRecoilValue(viewProductBreads);

    return (
        <Fade in={enabled} timeout={{ enter: 400, exit: 400 }}>
            <div id="section-3" className="contentModule">
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={Sourdough}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Sourdough
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>Experience the delight of a traditional Sourdough loaf, featuring a beautiful deep brown crust with a wonderfully chewy texture, complemented by a light, partially airy crumb with a mild tang. The bread is crafted through a lengthy rising and slow proofing process, ensuring that every bite is packed with flavor. A great choice for an amazing deli sandwich, grilled cheese or toast with jam!</p>
                                        <p>Ingredients: Flour, Water, Salt, Rice Flour ( dusting ).</p>
                                        <p>Price: $10 USD (per loaf)</p>
                                        <p>Price: $12 USD (cheddar cheese, per loaf)</p>
                                        <p>Price: $12 USD (cheddar cheese with jalapeño, per loaf)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={PainDeCampagne}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Pain de Campagne
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>Experience the joy of our Pain de Campagne, which boasts a crisp crust and lovely crumb that’s perfect for crafting sandwiches. The addition of rye flour combined with an extended rising time imparts a remarkable flavor and texture to this bread. This is a wonderfully flexible bread that you will surely enjoy.</p>
                                        <p>Ingredients: Flour, Water, Rye Flour, Salt and Yeast.</p>
                                        <p>Price: $10 USD (per loaf)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={HoneyWheatBread}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Honey Wheat Bread
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>Our Honey Wheat Bread blends the hearty goodness of whole wheat with a bit of golden honey for a perfect balance of flavor and nutrition. Baked fresh with simple ingredients, it's soft, has just a hint of sweetness, and is ideal for everything from morning toast to your favorite sandwiches. Packed with fiber and made without artificial preservatives, it’s bread you can feel good about—comforting, classic, and irresistibly delicious.</p>
                                        <p>Ingredients: Flour, Whole Wheat Flour, Water, Honey, Canola Oil, Salt, Malt Barley and Yeast.</p>
                                        <p>Price: $8 USD (per loaf)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={LemonHerbBread}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Lemon and Herb Bread
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>Delight in the vibrant flavors of our Lemon and Herb bread, where the aromatic herbs de Provence meet the lively brightness of lemon zest. This medium-sized loaf features a wonderfully chewy crust and a soft, airy crumb, making it a fantastic addition to your dinner table with a spread of your favorite butter. It’s also versatile enough to be enjoyed as a sandwich or simply toasted with a soothing cup of tea.</p>
                                        <p>Ingredients: Flour, Water, Whole Rye Flour, Salt, Herbes de Provence and Lemon Zest.</p>
                                        <p>Price: $8 USD (per loaf)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={OliveRosemaryBread}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Olive and Rosemary Bread
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>Our Olive and Rosemary bread is an ideal companion for Mediterranean cuisine, pasta dishes, or as a delightful addition to any charcuterie board featuring cheese, cured meats, and pickles. Infused with generous amounts of Kalamata olives and a subtle hint of rosemary, the flavors harmonize wonderfully. The bread boasts a crispy, chewy crust that gives way to a light, airy interior filled with olives. While it’s delicious on its own, we love to toast slices or cubes and serve them with our favorite olive oil dip and hummus.</p>
                                        <p>Ingredients: Flour, Spring Water, Whole Wheat Flour, Kalamata Olives, Salt, Fresh Rosemary and Whole Rye Flour.</p>
                                        <p>Price: $12 USD (per loaf)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={Miche}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Miche
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>Rooted in centuries-old French tradition, our Miche bread is a classic country-style loaf known for its hearty crust, complex flavor, and generous size. Naturally leavened and slow-fermented, this rustic sourdough is made with a blend of whole wheat and stone-ground flours, giving it a rich, earthy depth and an open, chewy crumb.</p>
                                        <p>Perfect for slicing, toasting, or serving alongside soups, cheeses, and charcuterie, the Miche is more than bread — it’s a statement piece for any table. Crafted with time, care, and old-world technique, it’s a true celebration of artisan baking.</p>
                                        <p>Ingredients: Flour, Whole Wheat Flour, Whole Rye Flour, Spring Water and Salt.</p>
                                        <p>Price: $12 USD (per loaf)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={CranberryWalnutBread}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Cranberry and Walnut Bread
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>Experience the delightful complexity of our Cranberry and Walnut bread, where earthy and nutty notes intertwine with the gentle sweetness of cranberries, creating a harmonious flavor profile. The crust boasts a deep mahogany hue and a satisfying crispness, while the interior features a sturdy, yet tender crumb that provides a rich mouthfeel, enriched by the diverse textures of walnuts and cranberries.</p>
                                        <p>Perfect for the holiday season, this bread makes for a wonderful non-traditional treat. We love to set out a loaf to pair with our holiday meals, savor it as toast with our morning coffee, or transform it into a mouthwatering turkey sandwich.</p>
                                        <p>Ingredients: Flour, Whole Wheat Flour, Whole Rye Flour, Spring Water, Walnuts, Dried Cranberries, Salt and Walnut Oil.</p>
                                        <p>Price: $12 USD (per loaf)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={RyeSourdough}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Rye Sourdough
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>Experience the rich and nuanced flavor of our Rye Sourdough, where earthy rye notes blend seamlessly with a gentle sourdough essence. The crust achieves a delightful crispness, showcasing a spectrum of colors from light brown to deep chestnut and mahogany. Add a delicious twist to your next sandwich with slices of our lightly toasted Rye Sourdough, available in small and large sizes.</p>
                                        <p>Ingredients: Flour, Spring Water, Rye Flour and Salt.</p>
                                        <p>Price: $10 USD (per loaf)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={Boule}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Rustic White Bread
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>Our Rustic White Bread is a delightful white bread bursting with flavor and plenty of holes. This naturally-leavened round loaf features a tender, chewy center encased in a beautifully dark, crusty shell. We skip the scoring process, letting natural cracks develop during baking. With a lengthy rise, this bread delivers a rich and memorable taste. Perfect for hearty sandwiches, delicious French toast, fantastic croutons, and so much more.</p>
                                        <p>Ingredients: Flour, Water, Salt and Yeast.</p>
                                        <p>Price: $8 USD (per loaf)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={PolentaBread}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Italian-Style Polenta Bread
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>Inspired by traditional Italian polenta breads, this naturally leavened loaf pairs the gentle sweetness of stone-ground corn with a blend of white and wheat flours for a rich, balanced flavor. A touch of rosemary adds an earthy, aromatic note without overpowering the bread’s natural character. The crust bakes thin and golden, giving way to a soft, creamy interior. Equally at home alongside soups, cheeses, or cured meats, it’s especially wonderful toasted—crisp on the outside, warm and tender within—finished simply with butter and a drizzle of honey.</p>
                                        <p>Ingredients: Flour, Water, Whole White Wheat, Polenta, Sunflower & Olive Oil, Salt and Rosemary.</p>
                                        <p>Price: $11 USD (per loaf)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={BraidedChallahBread}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Braided Challah Bread
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>Experience the delightful softness and rich flavor of our Braided Challah Bread. Its subtle sweetness makes it perfect for a classic PB&J sandwich, or you can slice it and toast it for an incredible bun. And if you’re in the mood for breakfast, it’s perfect for creating amazing French toast!</p>
                                        <p>Ingredients: Flour, Water, Eggs, Milk, Butter, Sugar, Sunflower / Olive Oil, Yeast, Salt and Malted Barley Flour.</p>
                                        <p>Price: $7 USD (per loaf, 2 loaf minimum)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={AleRolls}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Ale Rolls
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>Hearty and flavorful, these robust bread rolls deserve a place at the table alongside your favorite meal. Made with high quality ale and baked to perfection, these are sure to become your new favorite rolls. We like them with lots of butter or we often use them as sliders for a deli meat sandwich.</p>
                                        <p>Ingredients: Flour, Ale, Whole Wheat Flour, Butter, Yeast, Salt, Sunflower / Olive Oil.</p>
                                        <p>Price: $7 USD (7 count)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={MilkBread}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Milk Bread
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>Soft, fluffy, and subtly sweet, our Milk Bread is a classic that elevates everyday baking. Made with whole milk, butter, and flour, this enriched loaf boasts a tender crumb and golden crust—perfect for everything from sandwiches to French toast. Its pillowy texture and delicate flavor make it a favorite for both sweet and savory pairings. Baked to perfection with no artificial preservatives, our Milk Bread delivers comforting, homestyle goodness in every slice.</p>
                                        <p>Ingredients: Flour, Milk, Butter, Eggs, Sugar, Dry Milk, Yeast, Salt, Malted Barley Flour.</p>
                                        <p>Price: $8 USD (per loaf)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={Foccacia}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Focaccia - Italian Herb
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>Discover the incredible flavor of our Italian Herb Focaccia, freshly baked just for you! This light and fluffy bread is infused with aromatic herbs and finished with a sprinkle of flaky salt, creating a perfect balance of flavors. Whether you’re dipping it into savory marinara or vibrant pesto, or using it as a sandwich base, this focaccia is a versatile delight. It also makes a fantastic side for salads and soups, or try it grilled with butter for an extra special touch.</p>
                                        <p>Ingredients: Flour, Water, Sunflower / Olive Oil, Yeast, Salt, Oregano, Semolina and Malted Barley Flour.</p>
                                        <p>Price: $7 USD (per loaf, 2 loaf minimum)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={FoccaciaSundried}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Focaccia - Sun-Dried Tomatoes and Olives
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>Savor the bold, Mediterranean flavors of our handcrafted focaccia—golden and airy with a perfect crust. Each bite is infused with the rich sweetness of sun-dried tomatoes and the briny depth of Kalamata olives, finished with a drizzle of olive oil and a sprinkle of flaky sea salt. Perfect as a snack, a gourmet sandwich base, or a stunning side to your favorite meal.</p>
                                        <p>Ingredients: Flour, Water, Sun-Dried Tomatoes, Kalamata Olives, Sunflower / Olive Oil, Yeast, Salt, Oregano, Semolina and Malted Barley Flour.</p>
                                        <p>Price: $9 USD (per loaf, 2 loaf minimum)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={MilkBreadRolls}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Milk Bread Rolls
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>Our milk bread rolls are incredibly tender, soft, and airy. The milk creates a light, delicately sweet flavor. These are perfect for tear-and-share and make a great accompaniment to your family meal.</p>
                                        <p>Ingredients: Flour, Milk, Butter, Egg, Sugar, Water, Sunflower / Olive Oil, Dry Milk, Yeast, Salt and Malted Barley Flour.</p>
                                        <p>Price: $8 USD (10 count)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={MarbleRyeBread}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Marble Rye Bread
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>A timeless classic with a striking twist. Our Marble Rye is a handcrafted loaf that artfully blends light and dark rye doughs to create a beautiful marbled pattern and a bold, balanced flavor. Made with premium rye flour and a touch of caraway seeds, this bread offers a firm crust and a tender, flavorful crumb. Perfect for sandwiches, toast, or served alongside hearty soups, our Marble Rye delivers both visual appeal and exceptional taste in every slice.</p>
                                        <p>Ingredients: Flour, Whole Rye Flour, Spring Water, Potato Flour, Sunflower / Olive Oil, Nonfat Dry Milk, Onion Powder, Caraway Seeds, Sugar, Black Cocoa, Salt, Milk , Yeast and Malt Barley Flour.</p>
                                        <p>Price: $12 USD (per loaf)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={FrenchBread}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        French Bread
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>Our French bread boasts a delightful flavor, featuring a gorgeous golden crust. The inside is luxuriously soft and fluffy. This bread is incredibly versatile, making it ideal for various meals. We love using it for garlic toast, crafting PB&J sliders, or turning leftovers into scrumptious French toast or amazing croutons.</p>
                                        <p>Ingredients: Flour, Water, Sugar, Sunflower / Olive Oil, Salt, Yeast and Malt Barley Flour.</p>
                                        <p>Price: $7 USD (per loaf, 2 loaf minimum)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    {/*
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={RaspberryBread}
                                alt=""
                            />    
                            <></>                      
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Raspberry White Chocolate Bread ( Small )
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>This bread will knock your socks off! We always make the bread with fresh raspberries ( seeds are removed for a more enjoyable eating experience ) and a generous scattering of white chocolate throughout. Looks and smells amazing, and has a wonderfully soft texture and flavor. The bread has a slight chew on the crust with the interior boasting a lightly sweet and fruity flavor, it's almost dessert but can really be eaten anytime. We love to eat this for breakfast or with a nice cup of tea. Also makes a phenomenal PB&J.</p>
                                        <p>Ingredients: Flour, Water, White Chocolate, Fresh Raspberries, Sunflower / Olive Oil, Sugar, Yeast, Salt and Malted Barley Flour.</p>
                                        <p>Price: $8 USD (per loaf)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    */}
                </Grid>
            </div>
        </Fade>      
    );
}

export default ProductBreads;